export default __webpack_public_path__ + "static/media/icons-info.90e4ddd8.svg";